import React from "react";
import { Box, keyframes } from "@mui/material";

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const shimmerBase = {
  background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
  backgroundSize: "800px 100%",
  animation: `${shimmer} 1.5s infinite ease-in-out`,
  borderRadius: "4px",
};

const MapSkeleton = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden",
        borderRadius: "8px",
        bgcolor: "#f5f5f5",
      }}
    >
      {/* Map area shimmer */}
      <Box
        sx={{
          ...shimmerBase,
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
        }}
      />

      {/* Simulated map grid lines */}
      <Box
        sx={{
          position: "absolute",
          top: "30%",
          left: 0,
          right: 0,
          height: "1px",
          bgcolor: "rgba(0,0,0,0.05)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "60%",
          left: 0,
          right: 0,
          height: "1px",
          bgcolor: "rgba(0,0,0,0.05)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          left: "25%",
          top: 0,
          bottom: 0,
          width: "1px",
          bgcolor: "rgba(0,0,0,0.05)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          left: "50%",
          top: 0,
          bottom: 0,
          width: "1px",
          bgcolor: "rgba(0,0,0,0.05)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          left: "75%",
          top: 0,
          bottom: 0,
          width: "1px",
          bgcolor: "rgba(0,0,0,0.05)",
        }}
      />

      {/* Simulated zoom controls */}
      <Box
        sx={{
          position: "absolute",
          top: "12px",
          right: "12px",
          display: "flex",
          flexDirection: "column",
          gap: "2px",
        }}
      >
        <Box sx={{ ...shimmerBase, width: "40px", height: "32px", borderRadius: "2px" }} />
        <Box sx={{ ...shimmerBase, width: "40px", height: "32px", borderRadius: "2px" }} />
      </Box>

      {/* Simulated marker pins */}
      <Box
        sx={{
          ...shimmerBase,
          width: "28px",
          height: "28px",
          borderRadius: "50%",
          position: "absolute",
          top: "40%",
          left: "35%",
        }}
      />
      <Box
        sx={{
          ...shimmerBase,
          width: "28px",
          height: "28px",
          borderRadius: "50%",
          position: "absolute",
          top: "55%",
          left: "60%",
        }}
      />
      <Box
        sx={{
          ...shimmerBase,
          width: "28px",
          height: "28px",
          borderRadius: "50%",
          position: "absolute",
          top: "30%",
          left: "50%",
        }}
      />
    </Box>
  );
};

export default MapSkeleton;
